import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { BUSINESS, NAV } from "@/lib/content";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="site-nav"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 w-full z-50 transition-[background-color,border-color,padding] duration-500 ${
        scrolled ? "bg-[#FBF9F6]/80 backdrop-blur-xl border-b border-[#E5E0D8] py-4" : "bg-transparent py-6"
      }`}
    >
      <div className="max-w-[1500px] mx-auto px-6 md:px-12 flex items-center justify-between">
        <button data-testid="nav-logo" onClick={() => scrollTo("top")} className="text-left">
          <span className="font-serif text-2xl md:text-[28px] leading-none tracking-tight text-[#1A1A1A]">Simpliq</span>
          <span className="block eyebrow mt-1">Atelier · Vaughan</span>
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {NAV.map((item) => (
            <button
              key={item.to}
              data-testid={`nav-link-${item.to}`}
              onClick={() => scrollTo(item.to)}
              className="link-underline text-sm tracking-wide text-[#1A1A1A]"
            >
              {item.label}
            </button>
          ))}
          <a
            data-testid="nav-call"
            href={BUSINESS.phoneHref}
            className="bg-[#1A1A1A] text-[#FBF9F6] text-sm px-6 py-3 rounded-full hover:bg-[#8C7A6B] transition-colors duration-500"
          >
            Book a consultation
          </a>
        </nav>

        <button data-testid="nav-toggle" className="md:hidden" onClick={() => setOpen(!open)}>
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#FBF9F6] border-t border-[#E5E0D8] px-6 py-8 flex flex-col gap-6">
          {NAV.map((item) => (
            <button
              key={item.to}
              data-testid={`nav-mobile-${item.to}`}
              onClick={() => { scrollTo(item.to); setOpen(false); }}
              className="font-serif text-2xl text-left"
            >
              {item.label}
            </button>
          ))}
          <a href={BUSINESS.phoneHref} className="bg-[#1A1A1A] text-[#FBF9F6] text-center py-3 rounded-full">
            {BUSINESS.phone}
          </a>
        </div>
      )}
    </motion.header>
  );
};
